import {ColorGetAllResponse, getAll} from '@/common-pages/color/color-service';
import Analyze from '@/common-pages/color/color-tabs/analyze/analyze';
import React from 'react';
import ResultTab from '../components/result-tab/result-tab';
import {View} from 'react-native';
import ColorDraw from './draw';
import {Dialog} from '@rneui/themed';

const ColorResult = ({isActive}: {isActive?: boolean}) => {
  const [times, setTimes] = React.useState<ColorGetAllResponse[]>([]);
  const [configId, setConfigId] = React.useState<string>();
  const [analyzeLoading, setAnalyzeLoading] = React.useState(false);

  const getTimes = async () => {
    try {
      const res = await getAll();
      setTimes(res);
      if (res) {
        setConfigId(`${res[0].id}`);
      }
    } finally {
    }
  };

  React.useEffect(() => {
    if (isActive) {
      getTimes();
    }
  }, [isActive]);

  return (
    <div className="relative isolate overflow-y-auto flex-1 flex flex-col h-full min-h-0 pb-[4.5rem] bg-[#F2F2F2]">
      {!!configId && isActive ? <ColorDraw /> : <View />}
      <div className="sticky top-0 z-[9] flex-none bg-[#F2F2F2]">
        <div className="absolute inset-0 z-0 bg-[#F2F2F2]" />
        <div className="relative z-10">
          <ResultTab
            selectKey={configId}
            onSelectKey={setConfigId}
            tabs={times.map(item => {
              return {
                label: `${item.cycle}`,
                key: `${item.id}`,
              };
            })}
          />
        </div>
      </div>
      <Analyze
        isActive={isActive}
        configId={+configId!}
        onLoadingChange={setAnalyzeLoading}
      />
      {analyzeLoading ? (
        <div className="absolute inset-0 z-[80] flex items-center justify-center bg-[rgba(0,0,0,0.12)]">
          <Dialog.Loading />
        </div>
      ) : null}
    </div>
  );
};

export default ColorResult;
